import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TaxTypeTableModel } from 'src/app/models/tables/management/tax-type-table.model';
import { environment } from './../../../environments/environment';
import { TaxTypeModel } from './../../models/management/tax-type.model';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';

@Injectable({
  providedIn: 'root'
})
export class TaxTypeService {

  constructor(private _httpClient: HttpClient) { }

  createTaxType(taxTypetModel: TaxTypeModel): Observable<TaxTypeModel> {
    return this._httpClient.post<TaxTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.CreateTaxType}`,
      taxTypetModel);
  }

  deleteTaxType(taxTypeId: number): Observable<TaxTypeModel> {
    return this._httpClient.delete<TaxTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.DeleteTaxType}/${taxTypeId}`);
  }

  getAllJurisdictionsForSelect(): Observable<CustomListDropdown[]> {
    return this._httpClient.get<CustomListDropdown[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.GetAllJurisdictionsForSelectAsync}`,);
  }

  getAllTaxTypes(): Observable<Array<TaxTypeModel>> {
    return this._httpClient.get<Array<TaxTypeModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.GetAllTaxTypes}`);
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.GetColumnsForConsultation}`);
  }

  getTaxTypeById(taxTypeId: number): Observable<TaxTypeModel> {
    return this._httpClient.get<TaxTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.GetTaxTypeById}/${taxTypeId}`);
  }

  getTaxTypeByKeys(countryId: number, code: string): Observable<TaxTypeModel> {
    const params = new HttpParams()
      .set('countryId', countryId)
      .set('code', code || '')
    return this._httpClient.get<TaxTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.GetTaxTypeByCode}`, { params: params })
  }

  getAllTaxTypesByCountryId(countryId: number): Observable<Array<TaxTypeModel>> {
    return this._httpClient.get<Array<TaxTypeModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.GetAllTaxTypesByCountryId}/${countryId}`);
  }

  getTaxTypesForConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<TaxTypeTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<TaxTypeTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.GetTaxTypesForConsultation}`,
      filters, { params: params }
    );
  }

  updateTaxType(taxTypetModel: TaxTypeModel): Observable<TaxTypeModel> {
    return this._httpClient.put<TaxTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.taxType.UpdateTaxType}`,
      taxTypetModel);
  }

}
